import * as types from '../../action-types';
import { getSyndicator as initialState } from "../../initialState";

const getSyndicator = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SYNDICATOR_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SYNDICATOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SYNDICATOR_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SYNDICATOR_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSyndicator;
